export enum EventCategory {
  General = 'General',
  Filtering = 'Filtering',
  Uploading = 'Uploading',
  Sharing = 'Sharing',
  Vault = 'Vault',
  VaultTransfer = 'Vault Transfer',
  Links = 'Links',
  Notifications = 'Notifications',
  Contacts = 'Contacts',
  NabanActs = 'Naban Acts',
  Profile = 'Profile',
  Onboarding = 'Onboarding',
  Inheritance = 'Inheritance',
  Home = 'Home',
  CertificationSupportingDocuments = 'Certification Supporting Documents',
  CertificationNotary = 'Certification Notary',
  PartnerConnections = 'Partner Connections',
  InheritedVault = 'Inherited Vault',
  InheritedDocuments = 'Inherited Documents',
}
